import * as types from "./actionTypes";

const initialState = {
  isOpen: false,
  message: "",
  type: "",
};
const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_MODAL:
      return {
        ...state,
        isOpen: true,
        message: action.message,
        type: action.payload,
      };
    case types.HIDE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
};

export default modalReducer;
